<div class="row">
    <h1 class="col page-title">
        <i class="far fa-fw fa-sm fa-arrow-alt-circle-left cursor-pointer" (click)="goToLastPage()"></i>
        {{ titleText }}
        <i [hidden]="!isLoadingSomething" class="fas fa-fw fa-sm fa-circle-notch fa-spin spinner-color"></i>
    </h1>
</div>
